import React from "react";
import { useParams } from "react-router";
import { Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Loading from "../../../../components/Loading";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Error from "../../../../components/Error";
import useSchoolQueries from "../../hooks/useSchoolQueries";
import { useQuery } from "react-query";
import { mutateErrors } from "../../../../utils";
import { urlReplacer } from "../../../../utils";
import PageHeader from "../../../../components/PageHeader";
import AdminBranchListItem from "../../components/branches/AdminBranchListItem";
import Button from "../../../../components/Button";
import { AdapterLink } from "../../../../components/Adopter";
import { Routes } from "../../../../constants/routes";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

export function ShowPage() {
  const classes = useStyles();
  const { id } = useParams<{ id: string }>();
  const { fetchOne } = useSchoolQueries();

  const { isLoading, isFetching, isError, error, refetch, data } =
    useQuery<any>("school_" + id, () => {
      return fetchOne(id);
    });

  if (isLoading || isFetching) return <Loading />;

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  const school = data && data.data;

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={school.name}
          endAdornment={
            <Button
              color={"success"}
              variant={"contained"}
              component={AdapterLink}
              to={`/0/${urlReplacer(Routes.SCHOOL_BRANCH, { id })}/create`}
            >
              Add
            </Button>
          }
        />
      </Container>

      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={2}>
          {school.branches.map((branch, index) => (
            <AdminBranchListItem
              key={`SchoolBranchListItem_${branch.id}`}
              index={index}
              onDelete={refetch}
              branch={branch}
            />
          ))}
        </Grid>
      </Container>
    </>
  );
}

export default ShowPage;
